const COOKIE_NAME = 'p_uuid';
const COOKIE_DOMAIN = '.infakt.pl';
const COOKIE_TTL_MS = 60 * 60 * 1000;

export function ensurePUuidCookie() {
  if (readPUuidCookie()) return;

  const uuid = generateUuid();
  if (!uuid) return;

  const expires = new Date(Date.now() + COOKIE_TTL_MS).toUTCString();
  const domainAttr = window.location.hostname.endsWith('.infakt.pl') ? ` domain=${COOKIE_DOMAIN};` : '';
  document.cookie = `${COOKIE_NAME}=${uuid}; expires=${expires};${domainAttr} path=/;`;
}

export function readPUuidCookie() {
  return document.cookie.match(/(?:^|;\s*)p_uuid=([^;]+)/)?.[1];
}

function generateUuid() {
  if (typeof crypto === 'undefined') return null;
  if (crypto.randomUUID) return crypto.randomUUID();
  if (!crypto.getRandomValues) return null;

  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = Array.from(bytes, b => b.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

ensurePUuidCookie();
